'use client'

import { useEffect, useState } from 'react'
import Header from './components/Header'
import Hero from './components/Hero'
import Features from './components/Features'
import WhoItsFor from './components/WhoItsFor'
import HowItWorks from './components/HowItWorks'
import Pricing from './components/Pricing'
import Footer from './components/Footer'

export default function Home() {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768)
    }
    checkMobile()
    window.addEventListener('resize', checkMobile)
    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  return (
    <>
      {/* Structured Data for SEO */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@graph': [
              {
                '@type': 'Organization',
                '@id': 'https://venturecompass.ai/#organization',
                name: 'VentureCompass',
                url: 'https://venturecompass.ai',
                logo: {
                  '@type': 'ImageObject',
                  url: 'https://venturecompass.ai/images/og-image.png',
                  width: 1200,
                  height: 630,
                },
                description: 'Transform your startup journey with AI-powered insights, strategy, and execution support.',
                sameAs: [
                  'https://x.com/venturecompass',
                  'https://www.linkedin.com/company/venture-compass-ai/',
                ],
              },
              {
                '@type': 'WebSite',
                '@id': 'https://venturecompass.ai/#website',
                url: 'https://venturecompass.ai',
                name: 'VentureCompass',
                publisher: {
                  '@id': 'https://venturecompass.ai/#organization',
                },
                potentialAction: {
                  '@type': 'SearchAction',
                  target: 'https://venturecompass.ai/?s={search_term_string}',
                  'query-input': 'required name=search_term_string',
                },
              },
              {
                '@type': 'SoftwareApplication',
                name: 'VentureCompass',
                applicationCategory: 'BusinessApplication',
                operatingSystem: 'Web',
                offers: {
                  '@type': 'Offer',
                  price: '0',
                  priceCurrency: 'USD',
                },
                description: 'AI-powered business strategy and go-to-market platform for founders and startups.',
                aggregateRating: {
                  '@type': 'AggregateRating',
                  ratingValue: '4.8',
                  ratingCount: '50',
                },
              },
            ],
          }),
        }}
      />
      <main className="min-h-screen bg-white">
        {/* Skip to main content link for keyboard users */}
        <a
          href="#main-content"
          className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:px-6 focus:py-3 focus:bg-primary-500 focus:text-white focus:rounded-lg focus:shadow-lg"
        >
          Skip to main content
        </a>
        <Header />
        <div id="main-content" className="relative" style={{ height: isMobile ? 'auto' : '200vh' }}>
          <Hero />
          <Features />
        </div>
        <WhoItsFor />
        <HowItWorks />
        <Pricing />
        <Footer />
      </main>
    </>
  )
}



